import { isAfter, isBefore, startOfToday } from 'date-fns';

import getCurrentYearMonthAndDate from './getCurrentYearMonthAndDate';
import getDateMonthAndYear from './getDateMonthAndYear';
import { Month } from '../types';

function getFirstPossibleDateMonthAndYear({
  earliestDate,
  minDate,
  maxDate,
}: {
  earliestDate?: Date | null;
  minDate?: Date | null;
  maxDate?: Date | null;
}): Month {
  const today = startOfToday();

  if (earliestDate) {
    return getDateMonthAndYear(earliestDate);
  } else if (minDate && isAfter(minDate, today)) {
    return getDateMonthAndYear(minDate);
  } else if (maxDate && isBefore(maxDate, today)) {
    return getDateMonthAndYear(maxDate);
  }

  return getCurrentYearMonthAndDate();
}

export default getFirstPossibleDateMonthAndYear;
